import React from 'react'
import Link from 'gatsby-link'
import Wave from '../components/Wave'

import styled from 'styled-components'

import Logo from '../images/ppilogo.png'

const WaveTop = styled.div`
  position: absolute;
  width: 100%;
  top: -6px;
  transform: rotate(180deg);
`

const IndexPage = () => (
  <div>
    <div className="Hero">
      <div className="HeroGroup">
        <a className="Logolink" href="https://www.ppiweb.com">
          <img
            className="Logo"
            src="https://contentppi.s3.amazonaws.com/Media_Graphics/ppilogo.png"
          />
        </a>

        <h1>
          ADMIT IT™<br /> Self-Assessment
        </h1>
        <p>
          The first (and hardest) step toward moving from a mindset of{' '}
          <i>scarcity</i> to one of <i>possibility</i> is- to tell the truth.
          This is where all progress begins: admitting your role in helping to
          create whatever circumstances you are facing. To assist you in gaining
          a sober perspective of how you are currently conducting yourself and
          your affairs, we're providing you with this self-assessment quiz.
          Answer the following questions truthfully. After all, if you're not
          ready to be totally honest, you're not ready to cross the Great
          Divide.
        </p>

        <Link to="/page-2/">Take Assessment</Link>

        <Wave />
      </div>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js